// Copyright 2026 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
import { Alert } from '@mui/material';

import { Link } from '@northern.tech/common-ui/Link';

export const EmailVerificationWarning = ({ action, className = '' }: { action: string; className: string }) => (
  <Alert className={`flexbox align-items-center margin-bottom-small ${className}`} severity="warning">
    Email verification is required to {action}. Update your settings in{' '}
    <Link to="/settings/my-profile" color="inherit">
      My Profile
    </Link>
    .
  </Alert>
);
